import { defineComponent as _defineComponent } from 'vue'
import BaseModal from '@/components/modals/vfm/BaseModal.vue';
import CountryList from '@/features/buybox/components/CountryList.vue';
import { SnowplowContext } from '@/helpers/tracking/providers';
import { VFMHelper } from '@/helpers/vfm/vfm-helper';
import { useLanguageStore } from '@/stores/pinia/useLanguageStore';
import { onMounted } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'CountrySwitcherModal',
  props: {
    countrySelectedCallback: null,
    additionalContexts: null
  },
  setup(__props: any) {

const props = __props as {
	countrySelectedCallback?: (() => void) | null;
	additionalContexts?: SnowplowContext[];
};



const languageStore = useLanguageStore();

onMounted(async () => {
	// check to be sure we don't double request the locales on SSR and SPA together
	if (languageStore.locales.length === 0) {
		await languageStore.fetchLocales();
	}
});

async function closeSelf() {
	props.countrySelectedCallback?.();
	VFMHelper.close();
}

return { __sfc: true,props, languageStore, closeSelf, BaseModal, CountryList }
}

})